const EVENT = ['onClick', 'onDoubleClick', 'onMouseEnter', 'onMouseMove', 'onMouseLeave'];

// 注册鼠标事件
export const registerEventGeometry = (layer, props) => {
    EVENT.map(v => {
        layer[v] = () => {
            if (layer.getProperties) {
                let options = layer.getProperties();
                props[v] && props[v](options);
            }
        };
    });
};

export const registerEventLayer = (layer, props) => {
    EVENT.map(v => {
        layer[v] = (...args) => {
            props[v] && props[v](...args);
        };
    });
};
